export default __webpack_public_path__ + "static/media/graignes17.81469e07.jpg";